import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SignupService } from '../../../services/signup.service';
import { AccountStatus } from '../../../models';

@Component({
  selector: 'SignupVerifiedComponent',
  templateUrl: './signupverified.component.html'
})
export class SignupVerifiedComponent {
  verified: boolean;

  constructor(private route: ActivatedRoute, private signupService: SignupService) { }

  ngOnInit(): void {
    let sub = this.route.params
      .subscribe(params => this.accountVerification(params['token']));
  }

  private accountVerification(token: string) {
    this.signupService.verifyAccount(token)
      .subscribe(returnValue => this.verified = (returnValue == AccountStatus.verified));
  }
}
